import React, { useReducer, useMemo, useEffect, useState } from "react";
import { settingsReducer, settingsInitialState } from "./store/Settings.store";
import SettingsProvider from "./store/Settings.provider";
import { Header, ContentWrapperUi, SideNav } from "../../components";
import Profile from "./Profile/Profile";
import Integration from "./Integration/Integration";
import EditProfile from "./Profile/EditProfile/EditProfile";
import Api from "./api/api";
import "./Settings.css";
import queryString from "query-string";
import { FormattedMessage } from "react-intl";
import Workspace from "./Workspace/Workspace";

function Settings(props) {
  const [state, dispatch] = useReducer(settingsReducer, settingsInitialState);
  const [goToIntegrations, setGoToIntegrations] = useState(null);
  const [currentTab, setCurrentTab] = useState("profile");
  const store = useMemo(() => {
    return { state, dispatch };
  }, [state, dispatch]);
  useEffect(() => {
    const { integration } = queryString.parse(window.location.search);
    if (integration == "true") {
      return setCurrentTab("integration");
    }
    if (props.urlSegment) {
      setCurrentTab(props.urlSegment);
    }
  }, []);
  const onTabCLick = (tab) => {
    window.history.pushState(null, null, "/settings/" + tab);
    setCurrentTab(tab);
  };
  return (
    <SettingsProvider store={store}>
      <Header
        setNavToggle={() =>
          props.redux.setNavBarToggle(!props.redux.globalReducer.navToggle)
        }
        navToggle={props.redux.globalReducer.navToggle}
        currentPage={<FormattedMessage id={"sidenav.settings"} />}
        profile={props.redux.profile}
        remaining={props.redux.credits.remaining}
        organization={props.redux.organization}
      />
      <ContentWrapperUi>
        <SideNav navToggle={props.redux.globalReducer.navToggle} />
        <SettingsWrapper>
          <SettingsTabs
            goToIntegrations={goToIntegrations}
            urlSegment={props.urlSegment}
            onTabCLick={onTabCLick}
            currentTab={currentTab}
            organization={props.redux.organization.organization}
          />
          <div className="tab-content">
            {currentTab == "profile" && (
              <Profile
                profile={props.redux.profile}
                organization={props.redux.organization}
                goToIntegrations={goToIntegrations}
                remaining={props.redux.credits && props.redux.credits.remaining}
                organizationCredits={
                  props.redux.credits && props.redux.credits.organizationCredits
                }
                personalCredits={
                  props.redux.credits && props.redux.credits.personalCredits
                }
              />
            )}
            {currentTab == "workspace" &&
              props.redux.organization.organization && (
                <Workspace team={props.redux.organization.organization} />
              )}
            {currentTab == "integration" && (
              <Integration
                goToIntegrations={goToIntegrations}
                profile={props.redux.profile}
              />
            )}
            {currentTab == "api" && props.redux.organization.organization && (
              <Api
                goToIntegrations={goToIntegrations}
                organizationCredit={
                  props.redux.credits && props.redux.credits.organizationCredits
                }
              />
            )}
          </div>
        </SettingsWrapper>
      </ContentWrapperUi>
    </SettingsProvider>
  );
}
function SettingsTabs({
  goToIntegrations,
  urlSegment,
  onTabCLick,
  currentTab,
  organization,
}) {
  /*  useEffect(() => {
    if (urlSegment) {
      let tab = document.querySelector(`#${urlSegment}`);
      if (tab) tab.click();
    }
  }, []);*/

  return (
    <div className="workflow-detail-header">
      <div className="cstm-tabs-ui cs-tabs-slider">
        <ul className="nav nav-tabs">
          <li onClick={() => onTabCLick("profile")}>
            <a
              id={"profile"}
              data-toggle="tab"
              href="#profile_tab"
              className={currentTab == "profile" ? "active" : ""}
            >
              <FormattedMessage id={"tabs.yourprofile"} />
            </a>
          </li>
          {organization && (
            <li onClick={() => onTabCLick("workspace")}>
              <a
                id={"workspace"}
                data-toggle="tab"
                href="#workspace_tab"
                className={currentTab == "workspace" ? "active" : ""}
              >
                <FormattedMessage id={"sidenav.organization"} />
              </a>
            </li>
          )}
          <li onClick={() => onTabCLick("integration")}>
            <a
              id={"integration_tab"}
              data-toggle="tab"
              href="#integration_tab"
              className={currentTab == "integration" ? "active" : ""}
            >
              <FormattedMessage id={"tabs.integration"} />
            </a>
          </li>
          {organization && (
            <li onClick={() => onTabCLick("api")}>
              <a
                id={"api_tab"}
                data-toggle="tab"
                href="#api_tab"
                className={currentTab == "api" ? "active" : ""}
              >
                API
              </a>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}
function SettingsWrapper({ children }) {
  return (
    <div className="col-md-10 content-wrap">
      <div className="content-block">
        <div className="inner-content-wrap">
          <div className="wd-wrapper">{children}</div>
        </div>
      </div>
    </div>
  );
}
export default Settings;
